import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Austin Andrews
 * id CEFE04E6-CBE8-4DDD-BCF2-F445579B68FE
 * name elevation-rise
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/elevation-rise.svg
 * tags
 */
export const ElevationRiseIcon = createSvgIcon(<><path d="M3,21V17.29L10.78,12.8L14.55,15L21,11.25V21H3M21,8.94L14.55,12.67L10.78,10.5L3,15V12.79L10.78,8.3L14.55,10.5L21,6.75V8.94Z" /></>, 'ElevationRiseIcon');
export default ElevationRiseIcon